import { render, staticRenderFns } from "./EnumSidebar.vue?vue&type=template&id=2b32cac0&scoped=true&"
import script from "./EnumSidebar.vue?vue&type=script&lang=js&"
export * from "./EnumSidebar.vue?vue&type=script&lang=js&"
import style0 from "./EnumSidebar.vue?vue&type=style&index=0&id=2b32cac0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b32cac0",
  null
  
)

export default component.exports